// Script loaded for the custom clinical protocol section
  document.addEventListener('DOMContentLoaded', function() {
      // Optional interactive code can be added here if needed in the future
  });
